import { Table } from '@radix-ui/themes'
import React from 'react'

const TableComponent = ({ dataStructure, columns }) => {
    return (
        <div className="w-full overflow-x-auto">
            <Table.Root variant="surface" style={{ minWidth: '500px' }}>
                <Table.Header>
                    <Table.Row>
                        {columns.map((col) => (
                            <Table.ColumnHeaderCell key={col.key}>
                                {col.title}
                            </Table.ColumnHeaderCell>
                        ))}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {dataStructure.map((row, index) => (
                        <Table.Row key={row.id || row.bedId || row.userId || index} align={'center'}>
                            {columns.map((col) => (
                                <Table.Cell key={col.key}>
                                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                                </Table.Cell>
                            ))}
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table.Root>
        </div>
    )
}

export default TableComponent
